import { render, staticRenderFns } from "./OwnersAndContactsFormComponent.vue?vue&type=template&id=adb4d832&scoped=true"
import script from "./OwnersAndContactsFormComponent.vue?vue&type=script&lang=js"
export * from "./OwnersAndContactsFormComponent.vue?vue&type=script&lang=js"
import style0 from "./OwnersAndContactsFormComponent.vue?vue&type=style&index=0&id=adb4d832&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adb4d832",
  null
  
)

export default component.exports